import { render, staticRenderFns } from "./opcBoard.vue?vue&type=template&id=00c30d20&"
import script from "./opcBoard.vue?vue&type=script&lang=js&"
export * from "./opcBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports